<template>
  <div class="course-banner">
    <div class="course-content">
       <el-carousel ref="course" arrow="never" class="course-content-carousel" indicator-position="none" :autoplay="false">
        <el-carousel-item v-for="(item, index) in courseBanner" :key="item._id" class="course-content-item">
          <img class="cover-photo" :src="item.coverPhoto && item.coverPhoto.url"/>
          <div class="course-content-right">
            <div class="course-title">{{item.title}}</div>
            <div class="course-context">
              <pre v-html="item.post"></pre>
            </div>
            <div>
                <span class="ue-btn ue-btn-filling" @click="goPage(item._id)">开始学习</span><span class="course-time">课程时长：{{getCourseTime(item.totalTime)}}分钟</span>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="course-tabs">
      <div 
        class="course-tabs-item"
        :class="{'course-tabs-item-active': activeIndex === index}"
        v-for="(item, index) in courseBanner"
        @click="goPage(item._id)"
        :key="item._id"
        @mouseenter="changeItem(index)"
      >
      <div>
         {{item.title}}
      </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
export default {
  name: 'course-banner',
  data () {
    return {
      activeIndex: 0,
    }
  },
  computed: {
    ...mapGetters('post', ['courseBanner'])
  },
  methods: {
    ...mapActions('post', ['getCourseBanner']),
    changeItem (val) {
      this.activeIndex = val
      this.$refs.course.setActiveItem(val)
    },
    getCourseTime (totalTime) {
      return Math.floor(parseFloat(totalTime)/60) + ':' + Math.round(parseFloat(totalTime)) %60
    },
    goPage (id) {
      window.open(`coursedetail/${id}`)
    }
  },
  created () {
    this.getCourseBanner()
  }
}
</script>
<style lang="scss" scoped>
.course-banner {
  height:441px;
  background:rgba(248,248,248,1);
  border-radius:6px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  >.course-content {
    >.course-content-carousel{
      >div{
        height: 248px !important;
      }
    }
    .course-content-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: transparent;
      .cover-photo {
        width: 535px;
        height: 241px;
        border-radius: 4px;
      }
      .course-content-right{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        width: 518px;
        height: 241px;
        text-align: left;
        >.course-title{
          font-size: 18px;
          font-weight: bold;
          color: #333333;
        }
        >.course-context{
          color: #999999;
          line-height: 24px;
        }
        .course-time{
          font-weight: bold;
          font-family:MicrosoftYaHei-Bold;
          margin-left: 22px;
          color: #999999;
        }
      }
    }
  }
  >.course-tabs{
    display: flex;
    align-items: center;
    >:not(:first-child) {
      margin-left: 24px;
    }
    >.course-tabs-item-active {
      box-shadow:0px 0px 16px 0px rgba(51,51,51,0.1);
      font-family: MicrosoftYaHei-Bold;
      > div {
        border-left: 4px solid rgba(231,0,18,1) !important;
        color: #333333;
        font-weight: bold;
      }
    }
    >.course-tabs-item {
      width: 262px;
      height: 100px;
      background: #ffffff;
      padding: 26px;
      text-align: left;
      border-radius: 6px;
      border: 1px solid rgba(234, 234,234, 2);
      display: flex;
      align-items: center;
      >div {
        height: 40px;
        padding-left: 10px;
        line-height: 20px;
        color: #333333;
         border-left: 4px solid transparent;
      }
      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>


